<template>
  <b-container fluid>

<!-- User Interface controls -->
    <b-row>
      <b-col lg="6" class="my-4">
        <b-form-group
          label="Filter"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="md"
          class="mb-0"
        >
          <b-input-group size="md">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="cerca"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

<!-- Main table element -->

    <b-table
      striped
      bordered
      outlined
      hover
      :head-variant="headVariant"
      :items="items"
      :fields="fields"
      :busy="isBusy"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      sort-icon-left
      stacked="md"
      show-empty
      :select-mode="selectMode"
      responsive="sm"
      ref="selectableTable"
      selectable
      @row-selected="onRowSelected"
      @filtered="onFiltered"
    >
      <template #table-busy>
        <div class="text-center text-light my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <!-- A custom formatted header cell for field 'name' -->
      <template #cell(unitPrice)="row">
        <span style="font-weight: 700: ">{{ row.item.unitPrice | formatter }}</span>
      </template>
      <template #cell(packBasePrice)="row">
        <span style="font-weight: 700: ">{{ row.item.packBaseListPrice | formatter }}</span>
      </template>
      <template #cell(packStdPrice)="row">
        <span style="text-decoration: line-through">{{ row.item.packStdListPrice | formatter }}</span>
        <span style="font-weight: 700: "> -> {{ row.item.packStdListPrice * 0.9 | formatter }}</span>
      </template>
      <template #cell(packPlusPrice)="row">
        <span style="text-decoration: line-through">{{ row.item.packPlusListPrice | formatter }}</span>
        <span style="font-weight: 700: "> -> {{ row.item.packPlusListPrice * 0.85 | formatter }}</span>
      </template>
      <template #cell(packSuperPrice)="row">
        <span style="text-decoration: line-through">{{ row.item.packSuperListPrice | formatter }}</span>
        <span style="font-weight: 700: "> -> {{ row.item.packSuperListPrice * 0.8 | formatter }}</span>
      </template>
      <template #cell(actions)="row">
        <b-button size="sm" title="modifica PRICE" class="ml-1" style="" @click="editUnitPrice(row.item, $event.target)">
          <span class="material-icons" style="vertical-align: middle;">edit</span>
            EDIT
          </b-button>
      </template>
    </b-table>

    <b-row>
      <b-col sm="5" md="6" class="my-1">
        <b-form-group
          label="Per page"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

<!-- Info modal -->
    <b-modal :id="infoModal.id" size="md" ok-only ok-title="CHIUDI" ok-variant="secondary" @hide="resetInfoModal">
      <template #modal-header="{ close }">
        <b-container style="margin: auto; padding: 10px; background-color: #333; color: #FFF">
          <b-row> 
            <b-col>
              <img src="../../assets/logo.png" style="width: 160px;">
            </b-col>
            <b-col style="text-align: center; margin: auto;">
              <h3 >{{ infoModal.title }}</h3>
            </b-col>
            <b-col style="float: right; margin: auto;">
              <span style="float: right; margin-right: 10px;" @click="close()">X</span>
            </b-col>
          </b-row>
        </b-container>
      </template>
      <template>
        <b-form @submit.prevent="onSubmitUnitPrice">
          <b-row> 
            <b-col style="text-align: center; margin: auto;">
              Gruppo SELF: {{ infoModal.washGroup }}
            </b-col>
            <b-col style="text-align: center; margin: auto;">
              Prezzo BASE a lavaggio: 
              <b-form-input v-model="infoModal.unitPrice" style="text-align: center;" required></b-form-input>
              <!-- <nice-numeric-input v-model="infoModal.unitPrice"
                    placeholder="Inserire il prezzo "
                    label=""
                    name=""
                    currency="EUR"
                    locale="it-IT"
                    noControls="true"
                    /> -->
            </b-col>
          </b-row>
          <div class="form-group">
            <button size="md" class="btn btn-primary btn-block">SALVA</button>
          </div>
        </b-form>
      </template>
    </b-modal>
    <!-- <b-modal ref="my-modal" centered hide-footer title="Prezzo AGGIORNATO">
      <div class="d-block text-center">
         <h3>Price <strong>{{ infoModal.productName }}</strong> aggiornato.
         </h3>
      </div>
      <b-button class="mt-2" variant="outline-success" block @click="hideModal">
         CHIUDI
      </b-button>
   </b-modal> -->
  </b-container>
</template>

<script>
  import { db } from '../../firebase/config.js';
  //import NiceNumericInput from 'nice-numeric-input';
  //
  import { mapGetters } from 'vuex';

  export default {
    filters: { 
      formatter: (value) => {
        return new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: 'eur',
        }).format((value / 100).toFixed(2))
      }, 
    },
    data() {
      return {
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        row: {},
        selectAll: false,
        isBusy: true,
        headVariant: 'dark',
        items: [],
        userData: {},
        userDogs: [],
        userSubs: [],
        fields: [
          { key: 'washGroup', label: 'Gruppo SELF',  sortable: false,  },
          { key: 'unitPrice', label: 'Prezzo Unitario', sortable: false,
            class: 'text-center' 
          },
          { key: 'packBaseListPrice', label: 'BASE (x4 lav.)', sortable: false,
            class: 'text-center' 
          },
          { key: 'packStdPrice', label: 'STD (x7 lav.)', sortable: false, 
            class: 'text-center' 
          },
          { key: 'packPlusPrice', label: 'PLUS (x9 lav.)', sortable: false, 
            class: 'text-center' 
          },
          { key: 'packSuperPrice', label: 'SUPER (x12 lav.)', sortable: false, 
            class: 'text-center' 
          }, 
          { key: 'actions', label: 'Azioni' }
        ],
        currentPage: 1,
        perPage: 20,
        pageOptions: [20, 40, { value: 1000, text: "Tutte (1000)" }],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          docRef: '',
          washGroup: '',
          unitPrice: 0,
        }
      }
    },
    created() {
      this.isBusy = true
      const washGroupsRef = db.collection('washGroups')
      .where('orgId', '==', this.auth_user.claims.orgId)
      .orderBy('washPgm', 'asc')

      washGroupsRef
      .onSnapshot((snapshotChange) => {
        this.items = [];
        snapshotChange.forEach((doc) => {
          this.items.push({
            docRef: doc.ref,
            washPgm: doc.data().washPgm,
            washGroup: doc.data().washPgm + " - " + doc.data().name,
            currency: doc.data().currency,
            unitPrice: doc.data().unitPrice,
            packBaseListPrice: doc.data().unitPrice * 4,
            packStdListPrice: doc.data().unitPrice * 7,
            packPlusListPrice: doc.data().unitPrice * 9,
            packSuperListPrice: doc.data().unitPrice * 12
          })
        });
        this.isBusy = false
        console.debug(this.items)
      })
    },
    computed: {
      formatter(value) {
        return new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: 'eur',
        }).format((value / 100).toFixed(2))
      },
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
      totalRows() {
        return this.items.length
      },
      ...mapGetters({
        // map `this.***` to `this.$store.getters.***`
        auth_user: "user",
      }),
    },
    methods: {
      onRowSelected(items) {
        this.selected = items
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      toggleSelectAll() {
        this.selectAll = !this.selectAll
        if(this.selectAll) {
          this.selectAllRows()
        } else {
          this.clearSelected()
        }
      },
      onSubmitUnitPrice(event) {
        event.preventDefault()
        this.infoModal.docRef
        .set({unitPrice: this.infoModal.unitPrice}, {merge: true})
        .then(() => {
          alert("PRICE aggiornato!");
        })
        .catch((error) => {
          alert(error);
        });
        this.$root.$emit('bv::hide::modal', this.infoModal.id)
      },
      editUnitPrice(item, button) {
        event.preventDefault()
        this.infoModal = {
          id: 'info-modal',
          title: 'Aggiorna Unit PRICE',
          docRef: item.docRef,
          washGroup: item.washGroup,
          unitPrice: item.unitPrice
        }
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal = {}
      },
      showModal() {
        this.$refs['my-modal'].show()
      },
      hideModal() {
        console.log('aggiornamento PRICE')
        this.$refs['my-modal'].hide()
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    },
    components: {
      //NiceNumericInput,
    }
  };
</script>